import { ApiError, apiRequest } from './client';

// F88: E-Mail-Bestätigung (server/email-verification.js). Alle Aufrufe gehen gegen
// /api/auth/verify-email bzw. /api/auth/resend-verification.

export type VerifyEmailStatus = 'verified' | 'already' | 'expired' | 'invalid' | 'error';

/** Löst den Link ein (POST). 'expired'/'invalid' kommen als 400 und werden hier zu Status. */
export async function confirmEmailToken(token: string): Promise<VerifyEmailStatus> {
  try {
    const data = await apiRequest<{ status?: string }>('/api/auth/verify-email', {
      method: 'POST',
      body: { token },
    });
    return data?.status === 'already' ? 'already' : 'verified';
  } catch (error) {
    if (error instanceof ApiError && error.status === 400) {
      const status = (error.data as { status?: unknown } | null)?.status;
      return status === 'expired' ? 'expired' : 'invalid';
    }
    return 'error';
  }
}

export type ResendVerificationResult = 'sent' | 'already_verified' | 'rate_limited' | 'failed';

/** „Erneut senden" (angemeldet). Das Server-Limit sind 3 Links je Stunde. */
export async function resendEmailVerification(): Promise<ResendVerificationResult> {
  try {
    const data = await apiRequest<{ sent?: boolean; already_verified?: boolean }>('/api/auth/resend-verification', {
      method: 'POST',
    });
    if (data?.already_verified) return 'already_verified';
    return data?.sent ? 'sent' : 'failed';
  } catch (error) {
    if (error instanceof ApiError && error.status === 429) return 'rate_limited';
    return 'failed';
  }
}
